import cx from 'classnames'
import type React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { ButtonWithIcon } from '../Buttons'
import { LeftArrowIcon } from '../svgIcons'
import { AppBar, Toolbar } from '../Wrappers'
import type { PagingProps } from './Paging'
import { Paging } from './Paging'

export const FOOTER_CONTAINER_HEIGHT = 60
const FOOTER_SIDE_PADDING = 20

const AppBarWrapperDiv = styled.div`
  margin-top: ${FOOTER_CONTAINER_HEIGHT}px;
`

const StyledAppBar = styled(AppBar).attrs({ placement: 'bottom', tag: 'div' })`
  box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.15);
`

const StyledToolbar = styled(Toolbar)`
  min-height: ${FOOTER_CONTAINER_HEIGHT}px;
  flex: none;
  padding: 0 ${FOOTER_SIDE_PADDING}px;
  gap: 24px;
`

const ColumnDiv = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${FOOTER_SIDE_PADDING}px;

  &.right {
    justify-content: flex-end;
  }
`

const ButtonsContainerDiv = styled.div`
  display: inherit;
  align-items: inherit;
  gap: ${FOOTER_SIDE_PADDING}px;
`

interface PageFooterBarProps {
  backButtonMessage: NonNullable<React.ReactNode>
  backToListUrl: string
  leftColumnContent?: React.ReactNode
  pagingProps?: PagingProps
  rightColumnContent?: React.ReactNode
}

export function PageFooterBar({
  backButtonMessage,
  backToListUrl,
  leftColumnContent,
  pagingProps,
  rightColumnContent,
}: PageFooterBarProps) {
  return (
    <AppBarWrapperDiv>
      <StyledAppBar>
        <StyledToolbar>
          <ColumnDiv>
            <ButtonWithIcon
              variant="primaryText"
              size="small"
              icon={<LeftArrowIcon />}
              forwardedAs={Link}
              to={backToListUrl}
            >
              {backButtonMessage}
            </ButtonWithIcon>
            {leftColumnContent && <ButtonsContainerDiv>{leftColumnContent}</ButtonsContainerDiv>}
          </ColumnDiv>
          <ColumnDiv className={cx({ right: !rightColumnContent })}>
            {rightColumnContent && <ButtonsContainerDiv>{rightColumnContent}</ButtonsContainerDiv>}
            {pagingProps && <Paging {...pagingProps} />}
          </ColumnDiv>
        </StyledToolbar>
      </StyledAppBar>
    </AppBarWrapperDiv>
  )
}
